import React, { Component } from 'react';
import '../styles/PickedBookList.css';
import PickedBook from './PickedBook';

class PickedBookList extends Component {


renderBooks () {
  const books = this.props.selectedBooks;
  let numberOfBooksSelected = books.length;
  let elementsToBeReturned = [];
  for (let i = 0; i < 5; i++) {
    if (numberOfBooksSelected > 0) {
      elementsToBeReturned.push(
      <div key={books[i].id} className='bookContainer'>
        <PickedBook key={books[i].id} book={books[i]} removePickedBook={this.props.removePickedBook}/>
      </div>
    )
      numberOfBooksSelected--;
    } else {
      elementsToBeReturned.push(<div key={i} className='bookContainer unpicked'></div>);
    }
  }
  return elementsToBeReturned;

  // if (this.props.selectedBooks.length > 0) {
  //   return this.props.selectedBooks.map((book) => {
  //     return <PickedBook key={book.id} book={book} removePickedBook={this.props.removePickedBook} />
  //   })
  // } else {
  //   return null;
  // }
  
}
 render() {
   return (
     <div className='PickedBookList'>
       {this.renderBooks()}
     </div>
   )
 }
}

export default PickedBookList;


// WEBPACK FOOTER //
// ./src/components/PickedBookList.js